module.exports = __webpack_public_path__ + "static/media/size-guide.898dc278.jpg";